/**
 * Mock data for entities, students, and contacts.
 * Will be replaced by API calls.
 */

export interface Entity {
  id: string;
  name: string;
  studentCount: number;
}

export interface Student {
  id: string;
  studentId: string;
  entityId: string;
  firstName: string;
  lastName: string;
  email: string;
  status: 'active' | 'inactive' | 'withdrawn';
  enrollmentDate: string;
  contactCount: number;
}

export interface Contact {
  id: string;
  studentId: string;
  typeId: number;
  rank: number;
  contactValue: {
    val?: string;
    formattedAddress?: string;
    building?: string;
    unit?: string;
    streetNumber?: string;
    streetName?: string;
    postalDeliveryInfo?: string;
    locality?: string;
    region?: string;
    postcode?: string;
    country?: string;
  };
  isActive: boolean;
  isRecovery: boolean;
  bounced: boolean;
  bounceCount: number;
}

export const MOCK_ENTITIES: Entity[] = [
  { id: 'entity-1', name: 'Murdoch University', studentCount: 1247 },
  { id: 'entity-2', name: 'Curtin University', studentCount: 892 },
  { id: 'entity-3', name: 'Edith Cowan University', studentCount: 634 },
];

export const MOCK_STUDENTS: Student[] = [
  { id: 'STU-11111', studentId: 'STU-11111', entityId: 'entity-2', firstName: 'Jane', lastName: 'Doe', email: 'jane.doe@university.edu', status: 'active', enrollmentDate: '2021-09-01', contactCount: 6 },
  { id: 'STU-22222', studentId: 'STU-22222', entityId: 'entity-1', firstName: 'Alex', lastName: 'Thompson', email: 'alex.t@university.edu', status: 'active', enrollmentDate: '2022-02-15', contactCount: 4 },
  { id: 'STU-33333', studentId: 'STU-33333', entityId: 'entity-1', firstName: 'Maria', lastName: 'Garcia', email: 'maria.g@university.edu', status: 'active', enrollmentDate: '2023-01-10', contactCount: 3 },
  { id: 'STU-44444', studentId: 'STU-44444', entityId: 'entity-1', firstName: 'James', lastName: 'Wilson', email: 'j.wilson@university.edu', status: 'withdrawn', enrollmentDate: '2020-09-01', contactCount: 5 },
  { id: 'STU-55555', studentId: 'STU-55555', entityId: 'entity-2', firstName: 'Emily', lastName: 'Chen', email: 'e.chen@university.edu', status: 'active', enrollmentDate: '2023-07-20', contactCount: 2 },
  { id: 'STU-66666', studentId: 'STU-66666', entityId: 'entity-1', firstName: 'David', lastName: 'Lee', email: 'd.lee@university.edu', status: 'inactive', enrollmentDate: '2021-02-01', contactCount: 7 },
];

export const MOCK_CONTACTS: Contact[] = [
  { id: 'c1', studentId: 'STU-11111', typeId: 1, rank: 1, contactValue: { val: 'jane.doe@university.edu' }, isActive: true, isRecovery: false, bounced: false, bounceCount: 0 },
  { id: 'c2', studentId: 'STU-11111', typeId: 2, rank: 2, contactValue: { val: '+1 (555) 234-5678' }, isActive: true, isRecovery: false, bounced: false, bounceCount: 0 },
  { id: 'c3', studentId: 'STU-11111', typeId: 1, rank: 3, contactValue: { val: 'j.doe99@gmail.com' }, isActive: false, isRecovery: false, bounced: true, bounceCount: 3 },
  { id: 'c4', studentId: 'STU-11111', typeId: 14, rank: 4, contactValue: { val: 'jane.work@example.com' }, isActive: true, isRecovery: false, bounced: false, bounceCount: 0 },
  { id: 'c5', studentId: 'STU-11111', typeId: 12, rank: 5, contactValue: { val: 'Ext. 9904 (Bldg 4)' }, isActive: true, isRecovery: true, bounced: false, bounceCount: 0 },
  { id: 'c6', studentId: 'STU-11111', typeId: 17, rank: 6, contactValue: { formattedAddress: '123 Ivy Lane, Springfield, IL 62704' }, isActive: true, isRecovery: false, bounced: false, bounceCount: 0 },
  { id: 'c7', studentId: 'STU-22222', typeId: 1, rank: 1, contactValue: { val: 'alex.t@university.edu' }, isActive: true, isRecovery: false, bounced: false, bounceCount: 0 },
  { id: 'c8', studentId: 'STU-22222', typeId: 2, rank: 2, contactValue: { val: '+1 (555) 012-3456' }, isActive: true, isRecovery: false, bounced: false, bounceCount: 0 },
  { id: 'c9', studentId: 'STU-33333', typeId: 1, rank: 1, contactValue: { val: 'maria.g@university.edu' }, isActive: true, isRecovery: false, bounced: false, bounceCount: 0 },
];

export function getStudentsForEntity(entityId: string): Student[] {
  return MOCK_STUDENTS.filter((s) => s.entityId === entityId);
}

export function getContactsForStudent(studentId: string): Contact[] {
  return MOCK_CONTACTS.filter((c) => c.studentId === studentId);
}

export function getStudent(studentId: string): Student | undefined {
  return MOCK_STUDENTS.find((s) => s.id === studentId);
}

export function getEntity(entityId: string): Entity | undefined {
  return MOCK_ENTITIES.find((e) => e.id === entityId);
}
